<template>
    <div>
        <mt-cell title="首页" to="/m_index" is-link>
        </mt-cell>
        <mt-cell title="产品" to="/Mproduct" is-link>
        </mt-cell>
        <mt-cell title="客户服务" to="/McustomerService" is-link>
        </mt-cell>
        <mt-cell title="顾问招募" to="/MaddAdvisers" is-link>
        </mt-cell>
        <mt-cell title="小工具--橙蟹业务系统平台" to="/Mbusiness" is-link>
        </mt-cell>
        <mt-cell title="小工具--橙蟹报销软件" to="/Mapply" is-link>
        </mt-cell>
        <mt-cell title="关于橙蟹" to="/MaboutUs/1" is-link>
        </mt-cell>
    </div>
</template>

<script>
    export default {
        name: 'navList',
        data() {
            return {

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mobile/navList.vue